import { motion } from 'framer-motion';
import { useLang } from '../context/LangContext';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { fadeInUp, staggerContainer, staggerChild } from '../animations/variants';

const sections = [
  { titleKey: "legal.editor.title", textKey: "legal.editor.text" },
  { titleKey: "legal.hosting.title", textKey: "legal.hosting.text" },
  { titleKey: "legal.ip.title", textKey: "legal.ip.text" },
  { titleKey: "legal.liability.title", textKey: "legal.liability.text" },
];

export default function MentionsLegalesPage() {
  const { t } = useLang();

  return (
    <div data-testid="mentions-legales-page" className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.h1
            className="font-bold tracking-tight text-white mb-12"
            style={{ fontSize: 'clamp(36px, 5vw, 56px)' }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {t("legal.title")}
          </motion.h1>

          <motion.div
            className="space-y-10"
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
          >
            {sections.map((section, i) => (
              <motion.div key={i} variants={staggerChild}>
                <h2 className="text-xl font-semibold text-white mb-3">{t(section.titleKey)}</h2>
                <div className="text-sm text-neutral-400 leading-relaxed whitespace-pre-line">
                  {t(section.textKey)}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
